import BankTransfer from './BankTransfer.json'

const animation = {
    BankTransfer,
}

export default animation;